export default [
  {
    path: '/admin/setup-our-farmers',
    name: 'setup-Our-Farmers',
    meta: { requiresAuth: true },
    component: () => import('@/pages/website/setup-our-farmers/index.vue')
  }
]
